import { initialState } from "./index";
import { createSelector } from "@reduxjs/toolkit";

const selectCompaniesState = (state) => state.companies || initialState;

export const selectCompanies = createSelector(
  [selectCompaniesState],
  (companiesState) => companiesState.companies
);

export const showMarketers = createSelector(
  [selectCompaniesState],
  (companiesState) => companiesState.marketersList
);

export const selectCompanyInfoDetails = createSelector(
  [selectCompaniesState],
  (companiesState) => companiesState.infoDetails
);
